import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  output,
} from '@angular/core';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { NoTranslateMaterialSymbolsDirective } from '../../directives/noTranslateMaterialSymbols.directive';

export type CollapsibleShellState = 'expanded' | 'collapsed';

@Component({
  selector: 'app-collapsible-popup-shell',
  imports: [NoTranslateMaterialSymbolsDirective],
  templateUrl: './collapsible-popup-shell.component.html',
  styleUrl: './collapsible-popup-shell.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('expandCollapse', [
      state(
        'collapsed',
        style({
          height: '0px',
          opacity: 0,
          overflow: 'hidden',
        })
      ),
      state(
        'expanded',
        style({
          height: '*',
          opacity: 1,
          marginTop: '10px',
        })
      ),
      transition('collapsed <=> expanded', [
        style({ overflow: 'hidden' }),
        animate('300ms ease-in-out'),
      ]),
    ]),
  ],
})
export class CollapsiblePopupShellComponent {
  title = input.required<string>();
  statusText = input<string | null>(null);
  statusVariant = input<'active' | 'inactive' | 'warning' | null>(null);

  expanded = input<boolean>(false);
  expandable = input<boolean>(true);
  closeable = input<boolean>(true);

  expandedChange = output<boolean>();
  close = output<void>();

  // Permite a los consumidores reaccionar tras el toggle (por ejemplo Leaflet popup.update())
  toggled = output<boolean>();

  readonly animationState = (): CollapsibleShellState =>
    this.expanded() ? 'expanded' : 'collapsed';

  onToggle(): void {
    const next = !this.expanded();
    this.expandedChange.emit(next);
    this.toggled.emit(next);
  }

  onClose(): void {
    this.close.emit();
  }
}
